export default {
      id: "surveys-menu-usage",
      viewBox: "0 0 40 40",
      url: "/dist/svg/" + "sprite.svg#surveys-menu-usage",
      toString: function () {
        return this.url;
      }
    }